import { DSP, STRATEGY_TYPE } from 'constantsBase';
import { BULK_CREATE_WIZARD_BASE } from './constants';

export const getStrategyTypeByDsp = (dsp: string | number) => {
  switch (dsp) {
    case DSP.AMZN.id:
      return STRATEGY_TYPE.amznBudgetOptimization;
    case DSP.APN.id:
      return STRATEGY_TYPE.apnBudgetOptimization;
    case DSP.TTD.id:
      return STRATEGY_TYPE.ttdBudgetOptimization;
    case DSP.DBM.id:
      return STRATEGY_TYPE.dbmBudgetOptimization;
    default:
      return STRATEGY_TYPE.wmtBudgetOptimization;
  }
};

export const getStepUrl = (step: number) => `${BULK_CREATE_WIZARD_BASE}${step}`;
